import React, {useState, Fragment, useContext} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import JobBoardFiltersPopupList from "./JobBoardFiltersPopupList";
import JobBoardFiltersContext from "./JobBoardFiltersContext";
import {toggleJobBoardFilterArrayValue, toggleJobBoardFilterSimpleValue} from "../../../utilities/job";

const JobBoardFiltersPopupSuperFilter = (props) => {

  const {entityObject, responseReceived, contentDimensions, intl} = props;
  let {title, entityName, noValuesFound, renderList} = entityObject;
  const [searchInput, setSearchInput] = useState("");
  const [popupFilters, setPopupFilters] = useContext(JobBoardFiltersContext);

  const selectedFilter = popupFilters.find(filterObject => filterObject.name === entityName);

  if (searchInput) {
    const lowerCasedInput = searchInput.toLowerCase();
    renderList = renderList.filter(renderValue => {
      return renderValue.toLowerCase().includes(lowerCasedInput)
    })
  }

  const selectAll = () => {
    let newFilters = [...popupFilters];
    renderList.forEach(x => {
      newFilters = 
        [...toggleJobBoardFilterArrayValue(newFilters, entityName, x, true)]
      ;
    })
    setPopupFilters(newFilters);
  }

  const deSelectAll = () => {
    const newFilters = [...popupFilters];
    let index = newFilters.findIndex(fObject => fObject.name === entityName);
    if (index >= 0) {
      newFilters.splice(index, 1);
    }
    setPopupFilters(newFilters)
  }

  const selectEntity = (value) => {
    const newFilters = [...popupFilters];
    setPopupFilters(
      [...toggleJobBoardFilterArrayValue(newFilters, entityName, value)]
    )
  };

  return (
    <div className="jb-filters__content-cell" key={entityName}>
      <span className="generic-popup-title"><FormattedMessage id={title}/></span>
      {responseReceived ? (
        <Fragment>
          {renderList.length || searchInput ? (
            <div className="jb-filters__selections">
              <button className="ui-button3 ui-button3--white jb-filters__selections-button" onClick={selectAll}>
                <FormattedMessage id="jobBoard.filters.popup.selectAllButton"/>
              </button>
              <button className="ui-button3 ui-button3--white jb-filters__selections-button" onClick={deSelectAll}>
                <FormattedMessage id="jobBoard.filters.popup.deselectAllButton"/>
              </button>
            </div>
          ) : null}
          {renderList.length || searchInput ? (
            <div className="ui-search jb-filters__search">
              <input type="text" className={"ui-search__input" + (searchInput ? " ui-search__input--no-icon" : "")}
                     placeholder={intl.formatMessage({id: "assignPopup.searchPlaceholder"})}
                     onChange={(event => setSearchInput(event.target.value))}
                     value={searchInput}
              />
              <span className="ui-search__icon"/>
            </div>
          ) : null}
          <JobBoardFiltersPopupList renderList={renderList}
                                    selectedFilter={selectedFilter}
                                    selectEntity={selectEntity}
                                    noEntitiesFound={noValuesFound}
                                    contentDimensions={contentDimensions}/>
        </Fragment>
      ) : <div className="ui-loader"/>}
    </div>
  )
};

JobBoardFiltersPopupSuperFilter.propTypes = {
  entityObject: PropTypes.shape({
    title: PropTypes.string.isRequired,
    entityName: PropTypes.string.isRequired,
    noValuesFound: PropTypes.string.isRequired,
    renderList: PropTypes.array.isRequired
  }).isRequired,
  responseReceived: PropTypes.bool.isRequired,
  contentDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(JobBoardFiltersPopupSuperFilter)
)
